<template>
	<div style="height:80%;display: flex; justify-content: center; align-items: center">
		<div style="width: 100%">
			<div class="weui-cell weui-cell_active">
				<div class="weui-cell__hd"><label class="weui-label">车牌号</label></div>
				<div class="weui-cell__bd">
					<span> {{ this.plateno }} </span>
				</div>
			</div>
			<div class="weui-cell weui-cell_active">
				<div class="weui-cell__hd"><label class="weui-label">订单号</label></div>
				<div class="weui-cell__bd">
					<span> {{ this.orderSn }} </span>
				</div>
			</div>
			<div class="weui-cell weui-cell_active">
				<div class="weui-cell__hd"><label class="weui-label">开始日期</label></div>
				<div class="weui-cell__bd">
					<span> {{ this.startDate }} </span>
				</div>
			</div>
			<div class="weui-cell weui-cell_active">
				<div class="weui-cell__hd"><label class="weui-label">停车场ID</label></div>
				<div class="weui-cell__bd">
					<span> {{ this.parkinglotId }} </span>
				</div>
			</div>
			<div class="weui-cell weui-cell_active">
				<div class="weui-cell__hd"><label class="weui-label">缴费月数</label></div>
				<div class="weui-cell__bd">
					<span> {{ this.payMonth }} </span>
				</div>
			</div>
			<div class="weui-cell weui-cell_active">
				<div class="weui-cell__hd"><label class="weui-label">应收金额</label></div>
				<div class="weui-cell__bd">
					<span> {{ this.receivable }} </span>
				</div>
			</div>
			<div class="weui-cell weui-cell_active">
				<div class="weui-cell__hd"><label class="weui-label">实收金额</label></div>
				<div class="weui-cell__bd">
					<span> {{ this.money }} </span>
				</div>
			</div>
			<button class="weui-btn weui-btn_default" @click="toPay">支付</button>
		</div>

	</div>
</template>

<script>
import { pay, updateBySn } from "../../api/coupon/pay";
import Vue from "vue";
import { redirectToWeChatAuth } from "@/utils/redirect"
import { getOpenId, getBuyId } from "../../api/coupon/auth";
export default {
	name: "Fixedvehicle",
	data() {
		return {
			orderSn: undefined,
			parkinglotId: undefined,
			payMonth: undefined,
			money: undefined,
			receivable: undefined,
			plateno: undefined,
			openId: null,
			userBuyId: null,
			isSzBank: false,

		}
	},
	mounted() {
		let openIdForOrder = localStorage.getItem("userOpenId");
		let userBuyId = localStorage.getItem("userBuyId");
		if (this.$route.query.code || this.$route.query.auth_code) {
			if (this.checkBrowser.id == 13) {
				getOpenId(this.$route.query.code).then((res) => {
					if (res.code == 200) {
						//&& res.msg != 'null'
						localStorage.setItem("userOpenId", res.msg);
						this.openId = res.msg;
					} else {
						alert("未获得授权");
					}
				});
			} else {
				getBuyId(this.$route.query.auth_code).then((res) => {
					localStorage.setItem("userBuyId", res.msg);
					this.userBuyId = res.msg
				});
			}
		} else {
			if (this.checkBrowser.id == 13) {
				//如果是微信环境就进行微信授权
				if (!openIdForOrder) {
					this.isSzBank = true;
					redirectToWeChatAuth("/weChat/Fixedvehicle")
				} else {
					this.isSzBank = true
					this.openId = openIdForOrder;

				}
			} else {
				if (!userBuyId) {
					redirectToWeChatAuth("/weChat/Fixedvehicle")
				} else {
					this.isSzBank = false
					this.userBuyId = userBuyId;
				}
			}
		}

	},
	created() {
		if (this.$route.query.plateno) {
			this.plateno = this.$route.query.plateno;
		}
		if (this.$route.query.parkinglotId) {
			this.parkinglotId = this.$route.query.parkinglotId;
		}
		if (this.$route.query.orderSn) {
			this.orderSn = this.$route.query.orderSn;
		}
		if (this.$route.query.money) {
			this.money = this.$route.query.money;
		}
		if (this.$route.query.receivable) {
			this.receivable = this.$route.query.receivable;
		}
		if (this.$route.query.payMonth) {
			this.payMonth = this.$route.query.payMonth;
		}
		if (this.$route.query.startDate) {
			this.startDate = this.$route.query.startDate;
		}

	},
	methods: {
		toPay() {
			let payForm = {
				orderSn: this.orderSn,
				totalAmount: parseFloat(this.money).toFixed(2),
				goodsType: 7,
				parkinglotId: this.parkinglotId,
				// parkinglotId: 13,
				payType: this.isSzBank?13:12,
				openId: this.isSzBank?(this.openId||localStorage.getItem('userOpenId')):(this.userBuyId||localStorage.getItem('userBuyId'))
			};
			pay(payForm).then(res => {
				if (res.code == 200) {

					let browser = Vue.prototype.checkBrowser;
					let params = {
						orderSn: this.orderSn,
						paymentPlatform: "",
					}
					//微信
					if (browser.id == "13") {
						params.paymentPlatform = 13
						updateBySn(params).then(result => {
							if (result.code == 200) {
								this.$pay(res)
							}

						})
					} else if (browser.id == "12") {
						params.paymentPlatform = 12
						updateBySn(params).then(result => {
							if (result.code == 200) {
								this.$pay(res)
							}

						})
					} else {
						params.paymentPlatform = 12
						updateBySn(params).then(result => {
							if (result.code == 200) {
								this.$pay(res)
							}

						})
					}
					console.log(browser, 'browser');

				}
			})
		},
	}
}
</script>

<style scoped></style>
